import { ClickAwayListener, Fade, Grid } from "@material-ui/core";
import useStyles from "../../../../../styles";
import { Link } from "react-router-dom";
import { useLocation } from "react-router";
import ArrowDropDownRoundedIcon from "@material-ui/icons/ArrowDropDownRounded";
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { setTour } from "routes/actions";
import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Accordion from "@material-ui/core/Accordion";
import AccordionDetails from "@material-ui/core/AccordionDetails";
import AccordionSummary from "@material-ui/core/AccordionSummary";
import Typography from "@material-ui/core/Typography";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import "./style.css";
export default function Menu() {
  const location = useLocation();
  const classes = useStyles();

  const [showGuidFade, setShowGuidFade] = useState(false);
  const [showAghighSchool, setShowAghighSchool] = useState(false);
  const [showBorhan, setShowBorhan] = useState(false);
  const [showElectionFade, setShowElectionFade] = useState(false);
  const [expanded, setExpanded] = React.useState(false);
  const currentUser = useSelector((state) => state.main.currentUser);
  const tour = useSelector((state) => state.main.tour);
  const dispatch = useDispatch();
  const currentUserRoles = currentUser?.roles;

  const isAghighMentor = !!currentUserRoles?.some((item) =>
    item?.role?.includes("مربی")
  );
  const { canRegisterActivity } = useSelector(
    (state) => state?.main?.currentUser
  );

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };
  useEffect(() => {
    setExpanded(false);
  }, [location.pathname]);

  const startTour = (step) => {
    setTimeout(
      () =>
        dispatch(
          setTour({ ...tour, run: true, tourActive: true, stepIndex: step })
        ),
      500
    );
  };

  return (
    <Grid
      container
      className={classes.menuContainer}
      alignItems="center"
      // justify="space-between"
    >
      <Grid
        item
        component={Link}
        to="/activities"
        className={classes.menuItem}
        style={{
          backgroundColor: location.pathname === "/activities" ? "#fff" : null,
          color: location.pathname === "/activities" ? "#000" : null,
        }}
      >
        فعالیت‌‌ها
      </Grid>
      <Grid
        item
        component={Link}
        to="/league"
        className={classes.menuItem}
        style={{
          backgroundColor: location.pathname === "/league" ? "#fff" : null,
          color: location.pathname === "/league" ? "#000" : null,
        }}
      >
        لیگ
      </Grid>
      <Grid
        item
        component={Link}
        // to="/"
        to="/talayedaran"
        className={classes.menuItem}
        style={{
          backgroundColor: location.pathname === "/talayedaran" ? "#fff" : null,
          color: location.pathname === "/talayedaran" ? "#000" : null,
        }}
      >
         ثبت نام طلایه داران
        <div className="animateDot"></div>
      </Grid> 
      {/* <Grid
        item
        component={Link}
        // to="/"
        to="/enghelab/school/activites"
        className={classes.menuItem}
        style={{
          backgroundColor: location.pathname === "/enghelab/school/activites" ? "#fff" : null,
          color: location.pathname === "/enghelab/school/activites" ? "#000" : null,
        }}
      >
         مدرسه انقلاب
        <div className="animateDot"></div>
      </Grid> */}
      {/* <Grid
        item
        component={Link}
        // to="/"
        to="/life-with-verses"
        className={classes.menuItem}
        style={{
          backgroundColor: location.pathname === "/life-with-verses" ? "#fff" : null,
          color: location.pathname === "/life-with-verses" ? "#000" : null,
        }}
      >
        عملیات رمضان المبارک
        <div className="animateDot"></div>
      </Grid> */}
      {/* <Grid
        item
        component={Link}
        // to="/"
        to="/enghelab/school/register"
        className={classes.menuItem}
        style={{
          backgroundColor:
            location.pathname === "/enghelab/school/register" ? "#fff" : null,
          color:
            location.pathname === "/enghelab/school/register" ? "#000" : null,
        }}
      >
        ثبت نام مدرسه انقلاب
        <div className="animateDot"></div>
      </Grid> */}
      {/* <Grid
        item
        component={Link}
        // to="/"
        to="/book/register"
        className={classes.menuItem}
        style={{
          backgroundColor:
            location.pathname === "/book/register" ? "#fff" : null,
          color:
            location.pathname === "/book/register" ? "#000" : null,
        }}
      >
        ثبت نام کتاب کار
        <div className="animateDot"></div>
      </Grid> */}
      {/* <a href="https://aghighdanabazar.ir/" className={classes.menuItem}>
				دانابازار
			</a> */}
      {/* <a href="https://zobdehgan.com/" className={classes.menuItem}>
				خدمات علمی و درسی
			</a> */}
      <ClickAwayListener onClickAway={() => setShowAghighSchool(false)}>
        <Grid
          item
          className={classes.menuItem}
          onMouseEnter={() => setShowAghighSchool(true)}
          onMouseLeave={() => setShowAghighSchool(false)}
        >
          <span> مدرسه عقیق</span>
          <ArrowDropDownRoundedIcon />
          <Fade in={showAghighSchool}>
            <Grid container className={classes.electionPopupInHeader}>
              <Grid
                container
                className={classes.electionMenuItem}
                component={Link}
                to={`/associations/county/499`}
                onClick={() => {
                  setShowAghighSchool(false);
                  handleChange(false);
                }}
              >
                پایه هفتم
              </Grid>
              <Grid
                container
                className={classes.electionMenuItem}
                component={Link}
                to={`/associations/county/500`}
                onClick={() => {
                  setShowAghighSchool(false);
                  handleChange(false);
                }}
              >
                پایه هشتم
              </Grid>
              <Grid
                container
                className={classes.electionMenuItem}
                component={Link}
                to={`/associations/county/501`}
                onClick={() => {
                  setShowAghighSchool(false);
                  handleChange(false);
                }}
              >
                پایه نهم
              </Grid>
              <div className={classes.menuAccordionRoot}>
                <Accordion
                  expanded={expanded === "panel1"}
                  onChange={handleChange("panel1")}
                >
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel1bh-content"
                    id="panel1bh-header"
                  >
                    <Typography className={classes.heading}>
                      پایه دهم
                    </Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                    <Grid container direction="column">
                      <Grid
                        container
                        className={classes.electionMenuItem}
                        component={Link}
                        to={`/associations/county/502`}
                        onClick={() => {
                          setShowAghighSchool(false);
                          handleChange(false);
                        }}
                      >
                        ریاضی
                      </Grid>
                      <Grid
                        container
                        className={classes.electionMenuItem}
                        component={Link}
                        to={`/associations/county/503`}
                        onClick={() => {
                          setShowAghighSchool(false);
                          handleChange(false);
                        }}
                      >
                        تجربی
                      </Grid>
                      <Grid
                        container
                        className={classes.electionMenuItem}
                        component={Link}
                        to={`/associations/county/504`}
                        onClick={() => {
                          setShowAghighSchool(false);
                          handleChange(false);
                        }}
                      >
                        انسانی
                      </Grid>
                    </Grid>
                  </AccordionDetails>
                </Accordion>
                <Accordion
                  expanded={expanded === "panel2"}
                  onChange={handleChange("panel2")}
                >
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel2bh-content"
                    id="panel2bh-header"
                  >
                    <Typography className={classes.heading}>
                      پایه یازدهم
                    </Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                    <Grid container direction="column">
                      <Grid
                        container
                        className={classes.electionMenuItem}
                        component={Link}
                        to={`/associations/county/506`}
                        onClick={() => {
                          setShowAghighSchool(false);
                          handleChange(false);
                        }}
                      >
                        ریاضی
                      </Grid>
                      <Grid
                        container
                        className={classes.electionMenuItem}
                        component={Link}
                        to={`/associations/county/507`}
                        onClick={() => {
                          setShowAghighSchool(false);
                          handleChange(false);
                        }}
                      >
                        تجربی
                      </Grid>
                      <Grid
                        container
                        className={classes.electionMenuItem}
                        component={Link}
                        to={`/associations/county/505`}
                        onClick={() => {
                          setShowAghighSchool(false);
                          handleChange(false);
                        }}
                      >
                        انسانی
                      </Grid>
                    </Grid>
                  </AccordionDetails>
                </Accordion>
                <Accordion
                  expanded={expanded === "panel3"}
                  onChange={handleChange("panel3")}
                >
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel3bh-content"
                    id="panel3bh-header"
                  >
                    <Typography className={classes.heading}>
                      پایه دوازدهم
                    </Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                    <Grid container direction="column">
                      <Grid
                        container
                        className={classes.electionMenuItem}
                        component={Link}
                        to={`/associations/county/508`}
                        onClick={() => {
                          setShowAghighSchool(false);
                          handleChange(false);
                        }}
                      >
                        ریاضی
                      </Grid>
                      <Grid
                        container
                        className={classes.electionMenuItem}
                        component={Link}
                        to={`/associations/county/509`}
                        onClick={() => {
                          setShowAghighSchool(false);
                          handleChange(false);
                        }}
                      >
                        تجربی
                      </Grid>
                      <Grid
                        container
                        className={classes.electionMenuItem}
                        component={Link}
                        to={`/associations/county/510`}
                        onClick={() => {
                          setShowAghighSchool(false);
                          handleChange(false);
                        }}
                      >
                        انسانی
                      </Grid>
                    </Grid>
                  </AccordionDetails>
                </Accordion>
              </div>
            </Grid>
          </Fade>
        </Grid>
      </ClickAwayListener>
      <Grid
        item
        component={Link}
        to="/messaging/inbox"
        className={classes.menuItem}
        style={{
          backgroundColor: location?.pathname?.includes("/messaging")
            ? "#fff"
            : null,
          color: location?.pathname?.includes("/messaging") ? "#000" : null,
        }}
      >
        گفتگو/همراز
      </Grid>
      {currentUser?.menu?.election && (
        // <ClickAwayListener onClickAway={() => setShowElectionFade(false)}>
        <Grid
          item
          className={classes.menuItem}
          onMouseEnter={() => setShowElectionFade(true)}
          onMouseLeave={() => setShowElectionFade(false)}
          style={{
            backgroundColor: location?.pathname?.includes("/election")
              ? "#fff"
              : null,
            color: location?.pathname?.includes("/election") ? "#000" : null,
          }}
        >
          <Link to="/election"> انتخابات قرارگاه ملی</Link>
          {/* <ArrowDropDownRoundedIcon /> */}
          {/* <Fade in={showElectionFade}>
							<Grid container className={classes.electionPopupInHeader}>
								{currentUser?.menu?.election?.el1_slug && (
									<Grid
										container
										className={classes.electionMenuItem}
										component={Link}
										to={`/election/${currentUser?.menu?.election?.el1_slug}`}
										onClick={() => setShowElectionFade(false)}
									>
										انتخابات دبیران منطقه‌ای و اعضای شهری
									</Grid>
								)}
								{currentUser?.menu?.election?.el2_slug && (
									<Grid
										container
										className={classes.electionMenuItem}
										component={Link}
										to={`/election/${currentUser?.menu?.election?.el2_slug}`}
										onClick={() => setShowElectionFade(false)}
									>
										انتخابات دبیران شهری و اعضای استانی
									</Grid>
								)}
								{currentUser?.menu?.election?.el3_slug && (
									<Grid
										container
										className={classes.electionMenuItem}
										component={Link}
										to={`/election/${currentUser?.menu?.election?.el3_slug}`}
										onClick={() => setShowElectionFade(false)}
									>
										انتخابات دبیران استان و اعضای ملی
									</Grid>
								)}
								{currentUser?.menu?.election?.el4_slug && (
									<Grid
										container
										className={classes.electionMenuItem}
										component={Link}
										to={`/election/${currentUser?.menu?.election?.el4_slug}`}
										onClick={() => setShowElectionFade(false)}
									>
										انتخابات دبیر ملی و عضو شورای مرکزی
									</Grid>
								)}
							</Grid>
						</Fade> */}
        </Grid>
        // </ClickAwayListener>
      )}
      {/* {!tour?.run && (
				<ClickAwayListener onClickAway={() => setShowGuidFade(false)}>
					<Grid
						item
						className={classes.menuItem}
						onMouseEnter={() => setShowGuidFade(true)}
						onMouseLeave={() => setShowGuidFade(false)}
					>
						<span> راهنما</span>
						<ArrowDropDownRoundedIcon />
						<Fade in={showGuidFade}>
							<Grid container className={classes.electionPopupInHeader}>
								<Grid
									container
									className={classes.electionMenuItem}
									component={Link}
									to={`/`}
									onClick={() => {
										// setTimeout(() => startTour(0), 500);
										startTour(0);
										setShowElectionFade(false);
										setShowGuidFade(false);
									}}
								>
									صفحه اصلی
								</Grid>
								<Grid
									container
									className={classes.electionMenuItem}
									component={Link}
									to={`/activities`}
									onClick={() => {
										// setTimeout(() => startTour(4), 500);
										startTour(4);
										setShowElectionFade(false);
										setShowGuidFade(false);
									}}
								>
									فعالیت ها
								</Grid>
								{canRegisterActivity && (
									<Grid
										container
										className={classes.electionMenuItem}
										component={Link}
										to={`/add-activity`}
										onClick={() => {
											// setTimeout(() => startTour(22), 500);
											startTour(21);
											setShowElectionFade(false);
											setShowGuidFade(false);
										}}
									>
										افزودن فعالیت
									</Grid>
								)}
								<Grid
									container
									className={classes.electionMenuItem}
									component={Link}
									to={`/league`}
									onClick={() => {
										
										startTour(36);
										setShowElectionFade(false);
										setShowGuidFade(false);
									}}
								>
									لیگ
								</Grid>
								<Grid
									container
									className={classes.electionMenuItem}
									component={Link}
									to={`/messaging/inbox`}
									onClick={() => {
										startTour(48);
										setShowElectionFade(false);
										setShowGuidFade(false);
									}}
								>
									گفتگو
								</Grid>
								<Grid
									container
									className={classes.electionMenuItem}
									component={Link}
									to={`/profile/${currentUser?.slug}`}
									onClick={() => {
										
										startTour(65);
										setShowElectionFade(false);
										setShowGuidFade(false);
									}}
								>
									پروفایل
								</Grid>
								<Grid
									container
									className={classes.electionMenuItem}
									component={Link}
									to={`/associations${currentUser?.roles[0]?.url}`}
									onClick={() => {
										// setTimeout(() => startTour(71), 200);
										startTour(72);
										setShowElectionFade(false);
										setShowGuidFade(false);
									}}
								>
									صفحه انجمن
								</Grid>
								
							</Grid>
						</Fade>
					</Grid>
				</ClickAwayListener>
			)} */}
      <Grid
        item
        component={Link}
        to="/counter"
        className={classes.menuItem}
        style={{
          backgroundColor: location.pathname === "/counter" ? "#fff" : null,
          color: location.pathname === "/counter" ? "#000" : null,
        }}
      >
        پیشخوان
      </Grid>
      {isAghighMentor && (
        <ClickAwayListener onClickAway={() => setShowAghighSchool(false)}>
          <Grid
            item
            className={classes.menuItem}
            onMouseEnter={() => setShowBorhan(true)}
            onMouseLeave={() => setShowBorhan(false)}
          >
            <span>برهان</span>
            <ArrowDropDownRoundedIcon />
            <Fade in={showBorhan}>
              <Grid container className={classes.electionPopupInHeader}>
                <Grid
                  container
                  className={classes.electionMenuItem}
                  component={Link}
                  to={`/associations/county/514`}
                  onClick={() => {
                    setShowBorhan(false);
                  }}
                >
                  دوره پیش نیاز
                </Grid>
                <Grid
                  container
                  className={classes.electionMenuItem}
                  component={Link}
                  to={`/associations/county/515`}
                  onClick={() => {
                    setShowBorhan(false);
                  }}
                >
                  دوره کاردو مجازی
                </Grid>
              </Grid>
            </Fade>
          </Grid>
        </ClickAwayListener>
      )}
      <Grid
        item
        component={Link}
        to="/ideation/convocation"
        className={classes.menuItem}
        style={{
          backgroundColor: location.pathname === "/ideation" ? "#fff" : null,
          color: location.pathname === "/ideation" ? "#000" : null,
        }}
      >
        ایدنو
      </Grid>
    </Grid>
  );
}
